import { constants } from '../../Constants/constants';
import { BannerCreate } from "../Banner/BannerCreate";

export const LandingBannerCreate = () => {
  return <BannerCreate
    newPath={constants.PATH.LANDING.LANDING_BANNER_LIST}
    redirectPath={constants.PATH.LANDING.LANDING_BANNER}
    bannerType="LANDING"
    tab={0} />
};